module.exports = __webpack_public_path__ + "img/mayr_26.43ce9bd8.png";